export * from './lib/shared-data-access-api-i18n.module';
export * from './lib/interceptors/language-api-interceptor.service';
